import React, { useEffect } from 'react'
import MensurementIcon from '../../../assets/icons/MensurementIcon'
import CarIcon from '../../../assets/icons/CarIcon'
import InstallationIcon from '../../../assets/icons/InstallationIcon'
import MaintenanceIcon from '../../../assets/icons/MaintenanceIcon'
import ServicesCard from '../../cards/ServicesCard'

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import SectionHeader from '../SectionHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getServices } from '../../../services/actions/MainAction'
function ServicesSection({more=false}) {

    const contentData = useSelector(state => state.Data.contentData);
    const lang_id = useSelector(state => state.Data.lang_id);
    const services = useSelector(state => state.Data.services);
    const dispatch = useDispatch()
     useEffect(()=>{
        window.scrollTo(0,0);
        dispatch(getServices(lang_id))
      },[lang_id])
   const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1200 },
      items: 4
    },
    desktop: {
      breakpoint: { max: 1200, min: 800 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 800, min: 600 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1
    }
    };
  return (
   <section className='mt-[40px]'>
      <SectionHeader title={contentData?.section_2} />
     
      <div className='mt-[20px] relative px-[40px] max-[600px]:px-[20px]'>
         <Carousel 
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={responsive}
                ssr={true} 
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={2000}
                keyBoardControl={true}
                customTransition="all 2s"
                transitionDuration={2000}
                containerClass=""
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
                
              >
                {
                  services?.map((data, i)=>{
                    return(
                      <ServicesCard key={i} data={data} />
                    )
                  })
                }
         </Carousel>
      </div>
   </section>
  )
}

export default ServicesSection